/* Message reading size — ONE place that knows the stored key, the legal range,
 * and how an override reaches the page. Read at boot (main.jsx, so the size
 * applies whether or not you visit Settings) and on every change.
 *
 * null means FOLLOW THE TOKEN: --font-messages-size, the shell register's own
 * reading size. Only a drag pins a number.
 *
 * The override lands on <body>, deliberately NOT on <html>. The root has to
 * keep carrying the token's own value, because that is what the slider reads
 * to show "what you get if you don't choose" — put the override there and it
 * overwrites the very thing it needs to compare against, and the token can
 * never be read again. Body inherits into every message either way.
 */
const KEY = 'paradigm_msg_size'
const MIGRATED = 'paradigm_msg_size_unpinned'
const MIN = 12
const MAX = 24

/* Sizes the old Settings page wrote into storage just for BEING OPENED: it
 * seeded its slider from the token and immediately persisted it, so anyone who
 * ever looked at Appearance came away with the register's then-current default
 * pinned as if they had chosen it — and no later re-tuning of the token could
 * reach them. These are those defaults. Anything else was genuinely dragged
 * and is left alone. */
const AUTO_PINNED = [12, 14, 15]

/** One-time repair of that accidental pin. Runs before the first read. */
function unpinLegacyDefault() {
  if (localStorage.getItem(MIGRATED)) return
  localStorage.setItem(MIGRATED, '1')
  const raw = parseInt(localStorage.getItem(KEY) || '', 10)
  if (Number.isFinite(raw) && AUTO_PINNED.includes(raw)) localStorage.removeItem(KEY)
  // The old override lived on the root; clear it so the token is readable.
  document.documentElement.style.removeProperty('--font-messages-size')
}

/** The register's own size — what you get with nothing pinned. */
export function tokenMsgSize() {
  const tok = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--font-messages-size'), 10)
  return Number.isFinite(tok) ? tok : MAX
}

/** The stored override, or null to follow the token. */
export function readMsgSize() {
  unpinLegacyDefault()
  const raw = parseInt(localStorage.getItem(KEY) || '', 10)
  return Number.isFinite(raw) ? Math.min(MAX, Math.max(MIN, raw)) : null
}

/** Put a size on the page (and persist it). null clears the override. */
export function applyMsgSize(px) {
  if (px == null) {
    document.body.style.removeProperty('--font-messages-size')
    localStorage.removeItem(KEY)
    return null
  }
  const value = Math.min(MAX, Math.max(MIN, px))
  document.body.style.setProperty('--font-messages-size', `${value}px`)
  localStorage.setItem(KEY, String(value))
  return value
}
